import React from 'react'
import './plaintext.scss'
import { Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const PlainText = ({ data }) => {
    return (
        <>
            <div className='plain-common-text'>
                <Row>
                    <Col sm={12} md={12} lg={12} xl={8}>
                        <div className='left-details'>
                            <div className='Heading'>
                                <h3>{data[0].heading}</h3>
                            </div>
                            <div className='text'>
                                <p>{data[0].text}</p>
                            </div>
                            <NavLink to={data[0].linkUrl}>{data[0].linkText}</NavLink>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default PlainText